import React from 'react';
import { Image } from '@/shared/ui/image';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';
import {
  BodyTextMediumC,
  BodyTextMediumB,
  BodyTextRegularD,
  HeadingBoldH5,
  HeadingBoldH7
} from '@/shared/ui/typography2';
import Switch from '@/shared/ui/switch/switch';
import {
  CardContent,
  InfoBlock,
  TopInfo,
  BottomInfo,
  SwitchBlock,
  TextBlock,
} from './styles';
import { truncateHtml } from '@/shared/libs/truncate-html';

const CardBonuse = ({ mobileLandscape, data, settings, tBonus }) => {
  const { bonuseActive, setBonuseActive } = settings;

  return (
    <CardContent $active={bonuseActive === data?.id}>
      <InfoBlock>
        <Image
          width={mobileLandscape ? 56 : 79}
          height={mobileLandscape ? 75 : 105}
          style={{ borderRadius: '4px',opacity: bonuseActive === data?.id?1:0.6 }}
          src={resolveMediaPath(data?.pic)}
          alt={data?.game}
        />
        <TextBlock>
          <TopInfo>
            {mobileLandscape ? (
              <>
                <BodyTextMediumB>{data?.name}</BodyTextMediumB>
                <BodyTextMediumC>{data?.game}</BodyTextMediumC>
              </>
            ) : (
              <>
                <HeadingBoldH7>{data?.name}</HeadingBoldH7>
               {data?.game&&<BodyTextMediumC> {truncateHtml(data?.game, 30)}</BodyTextMediumC>} 
              </>
            )}
          </TopInfo>
          <BottomInfo>
            <BodyTextRegularD>
              {tBonus('card.bet_per_spin', { value: data?.bet })}
            </BodyTextRegularD>
          </BottomInfo>
        </TextBlock>
      </InfoBlock>
      <SwitchBlock>
        <Switch
        style={{background:bonuseActive !== data?.id? '#71407D':'#ff9500'}}
          onCheckedChange={() => setBonuseActive(data?.id)}
          checked={bonuseActive === data?.id}
        />
      </SwitchBlock>
    </CardContent>
  );
};

const CardBonuseWithBreakpointSlice = withBreakpointsSlice(
  CardBonuse,
  ({ mobileLandscape }) => ({ mobileLandscape })
);

export { CardBonuseWithBreakpointSlice as CardBonuse };
